import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import DespatchMonitoringOverviewColumns from '../../containers/DespatchMonitoringOverviewColumns';
import DespatchMonitoringOverviewReportMode from '../../DespatchMonitoringOverviewReportMode';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MONITORING_OVERVIEW.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.DESPATCH_MONITORING_OVERVIEW.isLoading;

export const getData = ReportsDefinition.DESPATCH_MONITORING_OVERVIEW.getDataFunction();

export const getImpcModeData = createSelector(
  getData,
  data => _.map(data, (row) => {
    const maxTail = moment.duration(row.data.maxTail);
    return {
      ...row,
      data: {
        ...row.data,
        maxTail: `${Math.trunc(maxTail.asHours())}:${maxTail.minutes()}`,
      },
    };
  }),
);

function longestDurationAsString(duration1, duration2) {
  const duration1HoursAndMinutes = duration1.split(':');
  const duration2HoursAndMinutes = duration2.split(':');

  if (Number(duration1HoursAndMinutes[0]) === Number(duration2HoursAndMinutes[0])) {
    if (Number(duration1HoursAndMinutes[1]) > Number(duration2HoursAndMinutes[1])) {
      return duration1;
    }

    return duration2;
  }

  if (Number(duration1HoursAndMinutes[0]) > Number(duration2HoursAndMinutes[0])) {
    return duration1;
  }

  return duration2;
}

export const getOperatorModeData = createSelector(getImpcModeData, data => _(data)
  .groupBy(row => (row.operatorCodes.origin + row.operatorCodes.destination))
  .map(operatorRelatedRows => operatorRelatedRows
    .reduce((operatorRow, operatorRelatedRow) => ({
      operatorCodes: operatorRelatedRow.operatorCodes,
      data: {
        closedDatesAfterArrivalDatesCount:
          operatorRelatedRow.data.closedDatesAfterArrivalDatesCount +
          operatorRow.data.closedDatesAfterArrivalDatesCount,
        predesTraffic: {
          despatches: operatorRow.data.predesTraffic.despatches +
            operatorRelatedRow.data.predesTraffic.despatches,
          receptacles: operatorRow.data.predesTraffic.receptacles +
            operatorRelatedRow.data.predesTraffic.receptacles,
        },
        resdesTraffic: {
          despatches: operatorRow.data.resdesTraffic.despatches +
            operatorRelatedRow.data.resdesTraffic.despatches,
          receptacles: operatorRow.data.resdesTraffic.receptacles +
            operatorRelatedRow.data.resdesTraffic.receptacles,
        },
        resdesVsPlanning: {
          withinPlan: operatorRow.data.resdesVsPlanning.withinPlan +
            operatorRelatedRow.data.resdesVsPlanning.withinPlan,
          missedBy2h: operatorRow.data.resdesVsPlanning.missedBy2h +
            operatorRelatedRow.data.resdesVsPlanning.missedBy2h,
          missedBy2to6h: operatorRow.data.resdesVsPlanning.missedBy2to6h +
            operatorRelatedRow.data.resdesVsPlanning.missedBy2to6h,
          missedBy6To24h: operatorRow.data.resdesVsPlanning.missedBy6To24h +
            operatorRelatedRow.data.resdesVsPlanning.missedBy6To24h,
          missedBy24to48h: operatorRow.data.resdesVsPlanning.missedBy24to48h +
            operatorRelatedRow.data.resdesVsPlanning.missedBy24to48h,
          missedBy48To72h: operatorRow.data.resdesVsPlanning.missedBy48To72h +
            operatorRelatedRow.data.resdesVsPlanning.missedBy48To72h,
          missedByMoreThan72h: operatorRow.data.resdesVsPlanning.missedByMoreThan72h +
            operatorRelatedRow.data.resdesVsPlanning.missedByMoreThan72h,
          noPlannedArrival: operatorRow.data.resdesVsPlanning.noPlannedArrival +
            operatorRelatedRow.data.resdesVsPlanning.noPlannedArrival,
          notScanned: operatorRow.data.resdesVsPlanning.notScanned +
            operatorRelatedRow.data.resdesVsPlanning.notScanned,
        },
        maxTail: longestDurationAsString(operatorRow.data.maxTail, operatorRelatedRow.data.maxTail),
      },
    }))).value());

export const getImpcModeColumns = createSelector(
  getImpcModeData,
  data => DespatchMonitoringOverviewColumns(data, DespatchMonitoringOverviewReportMode.impc),
);

export const getOperatorModeColumns = createSelector(
  getOperatorModeData,
  data => DespatchMonitoringOverviewColumns(data, DespatchMonitoringOverviewReportMode.operator),
);

